import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { SellerContainer } from '@/components/Seller/Table/Seller';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import { useState } from 'react';
import { AddSellerDialog } from '../AddSellerDialog/AddSellerDialog';

export default function SellerDirectory() {
  const [openNewSellerDialog, setOpenSellerDialog] = useState(false);

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Directorio de Vendedores'}
        sx={{ px: { xs: '16px', md: '0px' }, pb: { xs: '0px', md: '16px' } }}
        primaryButton={{
          label: 'Agregar Vendedor',
          variant: 'contained',
          leftIcon: <PersonAddAltOutlinedIcon />,
        }}
        onPrimaryButtonClicked={() => setOpenSellerDialog(true)}
      />
      <SellerContainer />
      <AddSellerDialog
        open={openNewSellerDialog}
        handleClose={() => setOpenSellerDialog(false)}
      />
    </TopLevelSectionLayout>
  );
}
